import { useEffect, useState } from "react";

/**
 * Subscribes to a CSS media query and returns whether it currently matches.
 * Handles both modern (addEventListener) and legacy (addListener) APIs.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    }
    mq.addListener(update);
    return () => mq.removeListener(update);
  }, [query]);

  return matches;
}

// Detects reduced-motion preference (used to disable scroll scrubbing gracefully).
export function useReducedMotion() {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}

// Detects coarse pointer (touch) devices — used for mobile-safe tuning.
export function useCoarsePointer() {
  return useMediaQuery("(pointer: coarse)");
}
